export default "__VITE_ASSET__cdd321f6__"